const SCRIPT_ID = "onetrust";

export const insertOneTrustScript = () => {
    const script = document.createElement("script");
    if (process.env["ONETRUST_SCRIPT_URL"]) {
        script.src = process.env["ONETRUST_SCRIPT_URL"];
    }
    if (process.env["ONETRUST_SCRIPT_GUID"]) {
        script.setAttribute("data-domain", process.env["ONETRUST_SCRIPT_GUID"]);
    }
    if (process.env["ONETRUST_DATA_TEST"]) {
        script.setAttribute("data-test", process.env["ONETRUST_DATA_TEST"]);
    }

    script.type = "text/javascript";
    script.setAttribute("data-geofence", "false");
    script.setAttribute("data-sync", "true");
    script.id = SCRIPT_ID;

    document.body.appendChild(script);
    return () => {
        document.body.removeChild(script);
    };
};
